import { PartnerMapUnion } from 'app/model';
import { ModelPrepped, ModelWithoutId } from 'app/type';

import { RestfulApiService } from './restful-api.service';

class PartnerMapQueryService extends RestfulApiService<PartnerMapUnion> {
    protected getFormName(): string {
        return 'partner_map_union';
    }

    protected getPath(): string {
        return 'partner-queries';
    }

    protected prepareSaveData(entity: ModelWithoutId<PartnerMapUnion>): ModelPrepped<PartnerMapUnion> {
        return {
            ...entity,
            queries: entity.queries.map((query) => {
                return {
                    ...query,
                    persistentBrand: query.persistentBrand?.id,
                    persistentStore: query.persistentStore?.id,
                    modifierBrands: query.modifierBrands.map((brand) => brand.id),
                    modifierStores: query.modifierStores.map((brand) => brand.id),
                };
            }),
        };
    }
}

export const partnerMapQueryService = new PartnerMapQueryService();
